module.exports = __webpack_public_path__ + "static/img/1_2_2_3.d90683f0.jpg";